import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-900 px-5 py-12 pb-28" data-id="element-150" data-mp="19j53j40hsmi0">
      <div className="mx-auto w-full max-w-3xl text-center" data-id="element-151" data-mp="208cc93t4l5p1">
        <p className="font-display text-base font-extrabold uppercase tracking-[0.24em] text-white" data-id="element-152" data-mp="209x4gmrywcjq">
          DRA. KARITO™
        </p>
        <p className="mt-2 text-[0.8rem] font-medium uppercase tracking-[0.12em] text-cyan-bright" data-id="element-153" data-mp="2a5gzl6ypj77f">
          Clinical Decision Systems for Modern Medicine
        </p>
        <p className="mt-4 text-[0.85rem] font-semibold text-slate-300" data-id="element-154" data-mp="1hh31kr7mcavv">
          Clinical Route for Erectile Dysfunction™
        </p>
        <p className="mx-auto mt-6 max-w-xl text-[0.78rem] leading-relaxed text-slate-500" data-id="element-155" data-mp="1w67naidmgx8q">
          Educational material intended for healthcare professionals. It does
          not replace individualized clinical judgment, current evidence-based
          guidelines, official prescribing information, or applicable local laws
          and regulations.
        </p>
        <p className="mt-6 text-[0.75rem] text-slate-600" data-id="element-156" data-mp="1ei2dbjwfobl0">
          © 2026 Dra. Karito™. All rights reserved.
        </p>
      </div>
    </footer>;
}